module.exports = __webpack_public_path__ + "img/55.06820012.jpg";